module.exports = __webpack_public_path__ + "assets/img/G4.040bfd1e.png";